<template>
  <div class="layer">
    <div class="inner">
      <button type="button" class="btnClose" @click="close"></button>
      <h2 class="layerTitle">상품이름</h2>
      <div class="info">
        <div class="mb15 isRequired">
          <div class="innerTitle setLabel">{{locale.name}}</div>
          <input type="text" class="input" v-model="name">
        </div>
        <div class="mb15 isRequired">
          <div class="innerTitle setLabel">{{locale.product_id}}</div>
          <input type="text" class="input" v-model="pId">
        </div>
        <div class="mb15 isRequired">
          <div class="innerTitle setLabel">{{locale.price}}</div>
          <input type="text" class="input" v-model="price">
        </div>
        <div class="mb15">
          <div class="innerTitle setLabel">{{locale.thumbnail}}</div>
          <p class="infoMessage mb5">썸네일 최적화 사이즈: 1000*740</p>
          <div v-if="thumb" class="bgThumb">
            <img :src="thumb" alt="" />
            <button type="button" class="delThumb" @click="deleteThumb"><img src="~@/assets/img/ico_close.svg" alt=""></button>
          </div>
          <div v-else><label class="btn btnFull btnWhite toUppercase">{{locale.upload}}<input type="file" @change="uploadImage($event)"></label></div>
        </div>
      </div>
      <div class="btns">
        <button v-if="id && id !== 'new'" type="button" class="btn btnRed btnLeft btnAuto" @click="delItem">{{ locale.delete }}</button>
        <button type="button" class="btn btnWhite" @click="close">{{ locale.cancel }}</button>
        <button type="button" class="btn btnPrimary">{{ locale.save }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import LANG from '@/common/lang'
import UNIQUE from '@/common/unique'
import regExp from '@/common/regExp'

export default {
  name: 'CreateItem',
  props: [
    'locale',
    'id'
  ],
  components: {
  },
  computed: {
  },
  created () {
    this.init()
  },
  mounted () {
  },
  beforeRouteLeave (to, from, next) {
  },
  data () {
    return {
      name: '',
      pId: '',
      price: 0,
      inventory: 999,
      thumb: ''
    }
  },
  methods: {
    async init () {
    },
    uploadImage (e) {
      const data = {
        id: UNIQUE.mid(),
        file: e.target.files[0]
      }
      const isImage = regExp.image.test(data.file.name.slice(data.file.name.lastIndexOf('.') + 1).toLowerCase())
      if (isImage) {
        this.$store.dispatch('util/uploadFile', data).then((res) => {
          this.thumb = res.source
          e.target.value = ''
        })
      } else {
        alert(this.locale.validate_upload_image)
      }
    },
    deleteThumb () {
      this.thumb = ''
    },
    delItem () {
      console.log('delete')
    },
    close () {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
.layer {
  .inner {
    max-width: 400px;
  }
}
.isRequired {
  .innerTitle {
    padding-left: 18px;
    &:after {
      content: "*";
      position: absolute;
      top: 0;
      left: 8px;
      color: $color-red;
    }
  }
}
</style>
